import { rage } from '../';

export function notifyOnError(
	_target: any,
	_propertyName: string,
	descriptor: PropertyDescriptor,
): void {
	const originalMethod = descriptor.value;

	descriptor.value = function (...args: unknown[]) {
		try {
			const result = originalMethod.apply(this, args);

			if (result instanceof Promise) {
				return result.catch((error: unknown) => {
					rage.notifications.showException(error);
					return Promise.reject(error);
				});
			}

			return result;
		} catch (error) {
			rage.notifications.showException(error);
			throw error;
		}
	};
}
